import { createFileRoute } from '@tanstack/react-router'
import { CircleX } from 'lucide-react'
import { CancelScreen } from '@/screens/billing/SCR-167-cancel'

export const Route = createFileRoute('/_app/billing/cancel')({
  staticData: { screen: { id: 'SCR-167', title: 'Cancel plan', group: 'Organisation', perm: 'billing.manage', hidden: true, description: 'What happens if you cancel, and when.', icon: CircleX } },
  component: CancelScreen,
})
